module.exports = __webpack_public_path__ + "static/media/trolley.f58e38cd.png";